module.exports = __webpack_public_path__ + "static/media/logo-white-720.c93e031a.png";